export var getIds = id => id ? {
  root: id,
  input: "".concat(id, "__input"),
  overflowingCircle: "".concat(id, "__overflowing__circle"),
  solidColor: "".concat(id, "__solid__color"),
  border: "".concat(id, "__border"),
  innerCircle: "".concat(id, "__inner__circle")
} : undefined;
//# sourceMappingURL=getIds.js.map